var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMatchfield(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_225_79946",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_225_79946)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "soccerfield",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.8182 5.45455V18.5455C22.8182 19.3488 22.167 20 21.3636 20H2.45455C1.65122 20 1 19.3488 1 18.5455V5.45455C1 4.65122 1.65122 4 2.45455 4H21.3636C22.167 4 22.8182 4.65122 22.8182 5.45455ZM3 8.36364V6H11.1364V9.05344C9.82861 9.39545 8.86364 10.585 8.86364 12C8.86364 13.415 9.82861 14.6045 11.1364 14.9466V18H3V15.5909H5.63636C5.93761 15.5909 6.18182 15.3467 6.18182 15.0455V8.90909C6.18182 8.60784 5.93761 8.36364 5.63636 8.36364H3ZM12.6818 14.9466V18H20.8182V15.5909H18.1818C17.8806 15.5909 17.6364 15.3467 17.6364 15.0455V8.90909C17.6364 8.60784 17.8806 8.36364 18.1818 8.36364H20.8182V6H12.6818V9.05344C13.9896 9.39545 14.9545 10.585 14.9545 12C14.9545 13.415 13.9896 14.6045 12.6818 14.9466ZM19.1818 9.90909H20.8182V14.0455H19.1818V9.90909ZM3 14.0455V9.90909H4.63636V14.0455H3ZM13.4091 12C13.4091 12.8284 12.7375 13.5 11.9091 13.5C11.0807 13.5 10.4091 12.8284 10.4091 12C10.4091 11.1716 11.0807 10.5 11.9091 10.5C12.7375 10.5 13.4091 11.1716 13.4091 12Z",
    fill: "#F6F6F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchfield);
export default __webpack_public_path__ + "static/media/matchfield.5e072bd341d3f449b3f58a391aaccc94.svg";
export { ForwardRef as ReactComponent };